<template>
  <div>
    <div v-if="loading" class="step-loading"></div>
    <v-card flat class="roi-card roi-card-transparent">
      <v-container fluid>
        <v-row>
          <v-col>
            <h4>{{ $t("result.headline") }}</h4>
            <template v-for="(item,index) in roiResultDataLocal.filterSelections">
              <v-chip
                :key="index"
                class="ma-2"
                color="primary"
              >
                <v-icon left small>
                  mdi-checkbox-marked-circle-outline
                </v-icon>
                {{ item.options[0].text }}
              </v-chip>
            </template>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="auto">
            <v-card
            >
              <v-card-text>
                <h4>{{ $t("result.costSavingPart1") }}<sup>*</sup> {{ $t("result.costSavingPart2") }} <br> {{ $t("result.costSavingPart3") }}</h4>
                <h1 class="mb-0" style="font-size: 300%;"><b>
                  <number
                    ref="number1"
                    :from="0"
                    :to=roiResultDataLocal.value
                    :duration="2"
                    easing="Power1.easeOut"/>
                  {{ roiResultDataLocal.currency }}</b></h1>
              </v-card-text >
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="auto">
            <v-card
              flat
            >
              <v-card-text >
                <p>{{ $t("result.lightningPart1") }} <b>{{ $t("result.lightningPart2") }}</b><br> {{ $t("result.lightningPart3") }}:</p>
                <h2 class="mb-0" style="font-size: 200%;color:#495057;"><b>
                  <number
                    ref="number1"
                    :from="0"
                    :to=roiResultDataLocal.lightning
                    :duration="2"
                    easing="Power1.easeOut"/>
                  {{ $t("result.lightningUnit") }}</b></h2>
              </v-card-text >
            </v-card>

          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <p>{{ $t("result.callbackPart1") }}<br>
              {{ $t("result.callbackPart2") }}<br>
              {{ $t("result.callbackPart3") }}</p>
          </v-col>
          <v-col
            sm="auto"
            v-if="roiCurrentStep === lastStep"

          >
            <v-btn
              class="btn-break"
              :href=ctaUrl target="_blank"
              color="primary"
              width="100%"
            >
              {{ $t("buttons.callback") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import {mapGetters,mapState} from "vuex";

export default {
  name: "StepResult",
  data () {
    return {
      roiResultDataLocal: {
        data: []
      },
    }
  },
  created() {
    if (this.roiCurrentStep === this.lastStep) {
      this.$store.dispatch('fetchAndSetRoiResultData').then(() => {
        this.roiResultDataLocal = this.$store.state.roiResultData;
      })
    }
  },
  computed: {
    ...mapGetters([
      'roiCurrentStep',
      'roiResultData'
    ]),
    ...mapState({
      loading: state => state.roiStepResultLoading,
      ctaUrl: state => state.roiResultData['url']
    }),
    lastStep: function() {
      return this.$store.state.roiSuperGroups.length + 1
    },
  },
  methods: {
  },
  watch: {
    roiCurrentStep (val) {
      if (val === this.lastStep) {
        this.$store.dispatch('fetchAndSetRoiResultData');
      }
    },
    roiResultData: {
      handler(newVal, oldVal){
        if (JSON.stringify(oldVal) !== JSON.stringify(newVal)) {
          this.roiResultDataLocal = this.$store.state.roiResultData;
        }
      },
      deep: true
    }
  },
}
</script>

<style lang="scss">

@import '../../src/sass/variables.scss';

@import '~vuetify/src/styles/settings/_variables';

.roi-card-transparent {
  background: none !important;
}

.btn-break .v-btn__content {
  width: 100%;
  white-space: normal;
  text-align: center;
}

</style>
